if (!customElements.get('otty-cross-sell-carousel')) {
    class OttyCrossSellCarousel extends HTMLElement {
        constructor() {
            super();
            this._index = 0;
        }

        connectedCallback() {
            this._cards = Array.from(this.querySelectorAll('otty-cross-sell-card'));
            this._dots = Array.from(this.querySelectorAll('.otty-cross-sell-dots .otty-cross-sell-dot'));
            this._prevBtn = this.querySelector('.otty-cross-sell-prev');
            this._nextBtn = this.querySelector('.otty-cross-sell-next');

            if (this._cards.length <= 1) {
                const controls = this.querySelector('.otty-cross-sell-controls');
                if (controls) controls.hidden = true;
                return;
            }

            this._buildDots();
            this._prevBtn.addEventListener('click', () => this._navigate(-1));
            this._nextBtn.addEventListener('click', () => this._navigate(1));

            this._update();
        }

        _buildDots() {
            this._dots.forEach((dot, i) => {
                dot.addEventListener('click', () => {
                    this._index = i;
                    this._update();
                });
            });
        }

        _navigate(dir) {
            this._index = (this._index + dir + this._cards.length) % this._cards.length;
            this._update();
        }

        _update() {
            this._cards.forEach((card, i) => {
                card.classList.toggle('otty-cross-sell-card__is-active', i === this._index);
            });

            this._dots.forEach((dot, i) => {
                dot.classList.toggle('otty-cross-sell-dot__is-active', i === this._index);
            });

            this._prevBtn.disabled = false;
            this._nextBtn.disabled = false;
        }
    }

    customElements.define('otty-cross-sell-carousel', OttyCrossSellCarousel);
}